<button
  mat-icon-button
  class="icon primary"
  [matMenuTriggerFor]="languageMenu"
  [attr.aria-label]="'COMMON.SELECT_LANGUAGE' | translate"
  [matTooltip]="'COMMON.SELECT_LANGUAGE' | translate">
  <mat-icon>language</mat-icon>
</button>

<mat-menu #languageMenu="matMenu" xPosition="before">
  @let currentLanguage = currentLanguage$ | async;

  @for (language of (languages$ | async); track language.id) {
    <button mat-menu-item (click)="onSelectLanguage(language.id, currentLanguage)">
      <mat-icon class="check-icon">
        {{ language.id === currentLanguage ? "check" : "" }}
      </mat-icon>

      <span>{{ language.name | translate }}</span>
    </button>
  }
</mat-menu>
